import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import { StationsService } from '@app/shared/services/stations.service';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '@app/shared/services/session.service';
import { MapService } from '@app/shared/services/map.service';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import * as L from 'leaflet';

@Component({
    selector: 'app-vehicle-logs',
    templateUrl: './vehicle-logs.component.html',
    styleUrls: ['./vehicle-logs.component.scss']
})
export class VehicleLogsComponent implements OnInit {

    public id: string = '0';
    public vehicle: any = {};
    public loading: boolean = true;
    public loadingMap: boolean = true;
    private currentDate: Date = new Date();
    private detailedPoints: Array<any> = [];
    private loadPoints: boolean = false;
    private points: Array<any> = [];
    private highlightedPoints: Array<any> = [];
    public highlightedDistance: string = '';

    /* Datepicker */

    public dateStart: string = moment().format('DD/MM/YYYY').split('T')[0];
    public dateEnd: string = moment().format('DD/MM/YYYY').split('T')[0];
    public dateStartChanged: Subject<string> = new Subject<string>();
    public dateEndChanged: Subject<string> = new Subject<string>();

    public hourStart: string = ('00' + (this.currentDate.getHours() - 2)).slice(-2) + ':' + ('00' + this.currentDate.getMinutes()).slice(-2);
    public hourStartChanged: Subject<string> = new Subject<string>();
    public hourEnd: string = ('00' + this.currentDate.getHours()).slice(-2) + ':' + ('00' + this.currentDate.getMinutes()).slice(-2);
    public hourEndChanged: Subject<string> = new Subject<string>();

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private vehicleService: VehiclesService,
        private stationService: StationsService,
        private route: ActivatedRoute,
        public session: SessionService,
        private mapService: MapService
    ) {
        this.dateStartChanged
            .subscribe(model => {
                this.dateStart = model;
                this.updateVehiclePath();
            });

        this.dateEndChanged
            .subscribe(model => {
                this.dateEnd = model;
                this.updateVehiclePath();
            });

        this.hourStartChanged
            .subscribe(model => {
                this.hourStart = model;
                this.updateVehiclePath();
            });

        this.hourEndChanged
            .subscribe(model => {
                this.hourEnd = model;
                this.updateVehiclePath();
            });
    }

    ngOnInit() {
        this.id = this.route.snapshot.paramMap.get('id');

        this.route.queryParams
            .subscribe(params => {
                console.log(params);

                if (params.start) {
                    console.log(this.dateStart, moment(params.start).format('DD/MM/YYYY').split('T')[0])
                    this.dateStart = moment(params.start).format('DD/MM/YYYY').split('T')[0];


                    //fuseaux horaire paris with moment
                    this.hourStart = moment(params.start).zone('+00:00').format('HH:mm');
                }

                if (params.end) {
                    this.dateEnd = moment(params.end).format('DD/MM/YYYY').split('T')[0];
                    this.hourEnd = moment(params.end).zone('+00:00').format('HH:mm');
                }
            });

        this.titleService.setTitle(`Logs techniques sur le véhicule / VOP`);
        this.menu.setMenuState('ressource', 'vehicle', 'log');
        this.menu.id = this.id;
        this.loadInformations();
        this.loadMap();
    }

    onDateChange(start, date): void {
        if (start === true) {
            this.dateStartChanged.next(date);
        } else {
            this.dateEndChanged.next(date);
        }
    }

    onHourChange(start, date): void {
        if (start === true) {
            this.hourStartChanged.next(date);
        } else {
            this.hourEndChanged.next(date);
        }
    }

    loadInformations() {
        this.loading = true;
        this.vehicleService.getVehicle(this.id).then((res) => {
            this.vehicle = res;
            this.loading = false;
        });
    }

    loadMap() {
        this.loadingMap = true;
        this.mapService.initMap('map', [43.6, 3.8833], 12).then(() => {
            this.loadingMap = false;
            this.points = [];
            this.highlightedPoints = [];
            this.updateVehiclePath();
            this.displayPoints();
            this.addStation();
        });

        this.mapService.map.scrollWheelZoom.enable();
    }

    addStation() {
        this.stationService.updateStations(0, "").then((res) => {
            console.log("station", res)
            res.forEach((station) => {
                this.mapService.addMarker([station.latitude, station.longitude], { type: "station" }).addTo(this.mapService.map).bindTooltip(`<span class="title">${station.name}</span>`)
            })
        });
    }

    removePoints() {
        this.mapService.markers.forEach((marker) => {
            if (marker.options.type !== "station") this.mapService.removeMarker(marker._leaflet_id);
        });
    }

    displayPoints() {
        this.mapService.map.on("mousemove", (e: any) => {
            var cursorPosition = e.latlng;

            if (this.loadPoints === true) {
                return;
            }

            if (this.points.length === 0) {
                return;
            }

            if (this.detailedPoints && this.detailedPoints.length > 0) {
                this.loadPoints = true;
                setTimeout(() => {
                    this.loadPoints = false;
                }, 250);
                this.removePoints();

                this.detailedPoints.forEach((point, index) => {
                    if (cursorPosition.lat - 0.0005 <= point.latitude && cursorPosition.lat + 0.0005 >= point.latitude
                        && cursorPosition.lng - 0.0005 <= point.longitude && cursorPosition.lng + 0.0005 >= point.longitude) {
                        let gpsDate = moment(point.ISOGpsDate).format().slice(0, -6).concat('.0000000Z');
                        let date = gpsDate.split('T')[0].split('-');
                        let hours = gpsDate.split('T')[1].split('.')[0].split(':');
                        let dateString = date[2] + '.' + date[1] + '.' + date[0] + ' à ' + hours[0] + ':' + hours[1];

                        this.mapService.addMarker([point.latitude, point.longitude], { icon: 'line' })
                            .bindTooltip(`<span class="title">${dateString}</span>`);
                    }
                });
            }
        });
    }

    updateVehiclePath() {
        console.log("UPDATE VEHICLE PATH", this.dateStart, this.dateEnd, this.hourStart, this.hourEnd)

        let start = moment(this.dateStart + "-" + this.hourStart, 'DD/MM/YYYY-h:mm').format() //.split('T')[0] + 'T' + this.hourStart + ':00.000Z';
        let end = moment(this.dateEnd + "-" + this.hourEnd, 'DD/MM/YYYY-h:mm').format() //.split('T')[0] + 'T' + this.hourEnd + ':59.000Z';

        console.log("BEFORE UPDATE", start, end)

        var time = moment.duration("02:00:00");

        //enlever 2 heures pour avoir l'heure de paris
        let dateStartUTC = moment(start).subtract(time).format()
        let dateEndUTC = moment(end).subtract(time).format();

        console.log("AFTER UPDATE", start, end)

        if (moment(dateEndUTC).isBefore(moment(dateStartUTC))) {
            this.dateEnd = moment(dateStartUTC).add(1, 'days').format('DD/MM/YYYY');
            this.hourEnd = this.hourStart;
            end = this.dateEnd
        }

        start = dateStartUTC.split('T')[0] + 'T' + dateStartUTC.split('T')[1].split('+')[0] + '.000Z';
        end = dateEndUTC.split('T')[0] + 'T' + dateEndUTC.split('T')[1].split('+')[0] + '.000Z';

        console.log("AFTER UPDATE", start, end)

        this.vehicleService.getVehicleGPSPoints(this.id, start, end).then((points) => {

            // return console.log(points)
            this.detailedPoints = points;
            this.points = [];
            this.highlightedPoints = [];
            this.removeLines();
            console.log(points)
            if (points && points.length === 0) {
                return;
            }
            this.drawInitialLine(points);
            this.drawHighlightedLine(points);
            this.calculateHighlightedDistance();
        });
    }

    calculateHighlightedDistance() {
        let distance = 0;
        this.highlightedDistance = '';
        if (this.highlightedPoints && this.highlightedPoints.length === 0) {
            return;
        }
        this.highlightedPoints.forEach((point: L.LatLngExpression, index) => {
            if (index > 0) {
                distance += L.latLng(this.highlightedPoints[index]).distanceTo(this.highlightedPoints[index - 1]);
            }
        });
        this.highlightedDistance = (distance / 1000).toFixed(1);
    }

    removeLines() {
        if (this.mapService.lines.length > 0) {
            this.mapService.lines.forEach((line) => {
                this.mapService.removePolyline(line._leaflet_id);
            });
            this.mapService.lines = [];
        }
    }

    drawInitialLine(points) {
        if (points.length === 0) return;

        console.log("POINTTTT", points, points.length)

        let beforePointX = points[0].latitude;
        let beforePointY = points[0].longitude;

        if (beforePointX === 0 && beforePointY === 0) {
            while (beforePointX == 0 && beforePointY == 0) {
                points.shift();
                if (points.length === 0) return;

                beforePointX = points[0].latitude;
                beforePointY = points[0].longitude;
            }
        }

        for (let point of points) {
            if ((point.latitude < beforePointX + 2 && point.latitude > beforePointX - 2) && (point.longitude < beforePointY + 2 && point.longitude > beforePointY - 2)) {
                this.points.push([point.latitude, point.longitude]);
                beforePointX = point.latitude
                beforePointY = point.longitude
            }
        }

        console.log(this.points)

        // points.forEach((point) => {
        //     //enleve les points bugger
        //     if ((point.latitude < beforePointX + 2 && point.latitude > beforePointX - 2) && (point.longitude < beforePointY + 2 && point.longitude > beforePointY - 2)) {
        //         this.points.push([point.latitude, point.longitude]);
        //         beforePointX = point.latitude
        //         beforePointY = point.longitude
        //     }
        // });

        this.mapService.drawPolyline(this.points, { color: '#F7A72A', opacity: 0.33, weight: 4 });
        this.mapService.resetLineView(this.mapService.lines[0]);
    }

    drawHighlightedLine(points) {
        if (points.length == 0) return

        let start = moment(this.dateStart, 'DD/MM/YYYY')
            .hour(parseInt(this.hourStart.split(':')[0], 10))
            .minute(parseInt(this.hourStart.split(':')[1], 10));
        let end = moment(this.dateEnd, 'DD/MM/YYYY')
            .hour(parseInt(this.hourEnd.split(':')[0], 10))
            .minute(parseInt(this.hourEnd.split(':')[1], 10));

        let beforePointX = points[0].latitude;
        let beforePointY = points[0].longitude;

        points.forEach((point) => {
            if (moment(point.ISOGpsDate) >= start && moment(point.ISOGpsDate) <= end) {
                if ((point.latitude < beforePointX + 2 && point.latitude > beforePointX - 2) && (point.longitude < beforePointY + 2 && point.longitude > beforePointY - 2)) {
                    this.highlightedPoints.push([point.latitude, point.longitude]);
                    beforePointX = point.latitude
                    beforePointY = point.longitude
                }
            }
        });

        this.mapService.drawPolyline(this.highlightedPoints, { color: '#F7A72A', opacity: 1, weight: 4 });
    }
}
